export default __webpack_public_path__ + "static/media/comingsoon.a7d3ea64.gif";